const basketCountSpan = document.querySelector(".count");
const basketIcon = document.querySelector(".basket-icon");
if(basketCountSpan.textContent > 0){
    basketIcon.classList.add("_active-basket");
    basketCountSpan.classList.add("count-active");
};


const wishCount = document.querySelector(".whish-count");
const wishIcon = document.querySelector(".whish-icon");
if(wishCount.textContent > 0){
    wishIcon.classList.add("whish-icon_active");
    wishCount.classList.add("count-active");
};

// const comparisonsCount = document.querySelector(".comparisons-count");
// const comparisonsIcon = document.querySelector(".comparisons-link");
// if(comparisonsCount.textContent > 0){
//     // comparisonsIcon.classList.add("whish-icon_active");
//     // comparisonsCount.classList.add("count-active");
//
// };

//============================== Валидация номера телефона ====================================================>
// let phone = $('.basket-quick-order__input').val(); // Получаем значение input
// let regex = /^(\+9|9|4)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
// if(!regex.test(phone)) {
//     console.log('Не соответствует');
// } else {
//     console.log('Соответствует');
// };

// var inputsTel = document.querySelectorAll('input[type="tel"]');
//
// Inputmask({
//     "mask": "+994(99) 999-99-99",
//     showMaskOnHover: false
// }).mask(inputsTel);
//============================== Mask phone ====================================================================>
// $(document).ready(function() {
//     $("#quick-order-mask").mask("+994 () ");
// });

$.mask.definitions['9'] = false;
$.mask.definitions['X'] = '[0-9]';
$('body input[type="tel"]').mask("+994 (XX)-XXX-XX-XX");



